export { default } from './SpinnerHero';
